var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Signal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.38 42H7v-4h13.38c2.7 0 3.5-5.76 4.2-10.83.91-6.6 1.85-13.43 7.46-13.43 6.39 0 7.1 10.47 7.93 22.6.38 5.48.76 11.16 1.74 14.82v.11c.64 3.13 1.84 4.25 2.33 4.3.32 0 .93-.41 1.53-1.75A49.13 49.13 0 0048 44.67c.36-1.79.7-3.48 1.09-5C50.59 34 55.2 34 56.94 34h12.87v4H56.94c-2 0-3.31.18-4 2.72-.36 1.37-.69 3-1 4.74a50.643 50.643 0 01-2.69 10c-1.6 3.56-3.89 4.12-5.16 4.12h-.46c-2.73-.3-4.9-3.08-5.8-7.42-1.06-4-1.44-9.61-1.85-15.52-.46-6.64-1.3-18.9-3.98-18.9-2.12 0-2.88 5.53-3.49 10-.9 6.67-1.95 14.26-8.13 14.26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Signal.df1a5ac2.svg";
export { SvgG1Signal as ReactComponent };